import { create } from 'zustand';

interface User {
  id: string;
  email: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isLogat: boolean;
  isAnonim: boolean;
  setAuth: (user: User, token: string) => void;
  setAnonim: () => void;
  logout: () => void;
}

function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    // JWT foloseste base64url — convertim la base64 standard inainte de atob
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

const storedToken = localStorage.getItem('token');
if (!isTokenValid(storedToken)) {
  localStorage.removeItem('token');
}
const initialToken = isTokenValid(storedToken) ? storedToken : null;

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: initialToken,
  isLogat: initialToken !== null,
  isAnonim: sessionStorage.getItem('anonim') === 'true',

  setAuth: (user, token) => {
    localStorage.setItem('token', token);
    sessionStorage.removeItem('anonim');
    set({ user, token, isLogat: true, isAnonim: false });
  },

  setAnonim: () => {
    sessionStorage.setItem('anonim', 'true');
    set({ isAnonim: true, isLogat: false });
  },

  logout: () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('anonim');
    set({ user: null, token: null, isLogat: false, isAnonim: false });
  },
}));
